module.exports = __webpack_public_path__ + "static/img/appointment1.890ea83.jpg";


//////////////////
// WEBPACK FOOTER
// /src/assets/img/screens/appointment1.jpg
// module id = /h4g
// module chunks = 1